module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0054.jpg?v=1bc15005";